module.exports = __webpack_public_path__ + "static/media/logo_white.a3360386.png";